import { render, staticRenderFns } from "./ProductSelectionButton.vue?vue&type=template&id=165018c1&"
import script from "./ProductSelectionButton.vue?vue&type=script&lang=js&"
export * from "./ProductSelectionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports